<template>
  <div id="app">
    <SchoolLiveDashboard v-if="viewMode === 'school'" />
    <template v-else>
      <trajectory />
      <!-- <div class="player-overlay">
        <Player />
      </div> -->
      <MQTT />
    </template>
  </div>
</template>

<script>
import MQTT from './components/MQTT.vue'
import SchoolLiveDashboard from './components/SchoolLiveDashboard.vue'
import trajectory from './components/trajectory.vue';

export default {
  name: 'app',
  components: {
    MQTT,
    SchoolLiveDashboard,
    trajectory
  },
  data() {
    return {
      viewMode: new URLSearchParams(window.location.search).get('view') || 'student'
    }
  }
}
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
</style>
